import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'

import styles from './styles.css'

class Dropdown extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    className: PropTypes.string.isRequired,
    defaultText: PropTypes.string,
  }

  static defaultProps = {
    defaultText: 'Select Reminder Type',
  }

  state = {
    showMenu: false,
    selectedOption: 0,
  }

  componentWillMount() {
    const { value, menuItems } = this.props
    if (value !== undefined) {
      const found = menuItems.filter(item => item.key * 1 === value)
      if (found.length > 0) {
        this.setState({ selectedOption: found[0].name })
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { value, menuItems } = nextProps
    if (value !== undefined) {
      const found = menuItems.filter(item => item.key * 1 === value)
      if (found.length > 0) {
        this.setState({ selectedOption: found[0].name })
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeMenu)
  }

  onClickOption = e => {
    this.props.onChange(e)
    const selectedOption = e.currentTarget.name
    if (this.refs.menuRef) {
      this.setState({ selectedOption })
    }
  }

  showMenu = event => {
    event.preventDefault()
    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu)
    })
  }

  closeMenu = () => {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener('click', this.closeMenu)
    })
  }

  render() {
    const { id, menuItems, className, defaultText } = this.props
    const { showMenu, selectedOption } = this.state
    return (
      <div className={classnames(className)}>
        <button className={classnames(styles['Grid-cell'], styles.card)} onClick={this.showMenu}>
          <p className={classnames(styles.selectedOption, styles.selectItem)}>
            {selectedOption || defaultText}
          </p>
          <p className={classnames(styles.caret, styles.selectItem)}>
            {showMenu ? String.fromCharCode(9650) : String.fromCharCode(9660)}
          </p>
        </button>
        {showMenu && (
          <div ref="menuRef" className={classnames(styles['Grid-cell'], styles.menu)}>
            {menuItems.map((item, index) => (
              <button
                key={item.key}
                id={id}
                value={item.key}
                name={item.name}
                onClick={this.onClickOption}
                className={classnames(
                  styles['Grid-cell'],
                  styles.middleCard,
                  [index === 0 && styles.firstCard],
                  [index === menuItems.length - 1 && styles.lastCard]
                )}
              >
                <p className={classnames(styles.selectItem)}>{item.name}</p>
              </button>
            ))}
          </div>
        )}
      </div>
    )
  }
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js